import { decodeJwt } from 'jose';
import Cookies from 'js-cookie';

function readMeta(name, attribute) {
  const tag = document.querySelector(`meta[name=${name}]`);
  if (!tag) {
    return null;
  }
  if (attribute) {
    return tag.getAttribute(attribute);
  }
  return tag.getAttribute('content');
}

function readDomainCookie(name) {
  const d = readMeta('cookie_domain');
  if (d) {
    return Cookies.get(name, { domain: d });
  }
  return Cookies.get(name);
}

function currentJwt() {
  return readDomainCookie('jwt');
}

function jwtData() {
  const token = currentJwt();
  if (!token) return {};

  try {
    return decodeJwt(token);
  } catch (e) {
    return {};
  }
}

function jwtSubject() {
  return jwtData().sub || null;
}

export {
  readMeta,
  readDomainCookie,
  currentJwt,
  jwtData,
  jwtSubject,
};

